import React from 'react';

import { FontAwesome } from 'react-js-vector-icons';

import Loading from './Loading';
import Message from '../component/Message';

export default class Header extends React.Component {
  backButton = () => {
    let back = null;

    if( this.props.back !== false ) {
      back = (
        <span>
          <a onClick={ () => window.history.back() } style={{ cursor: 'pointer' }}>
            <FontAwesome name="arrow-left" color="white" size={16} style={{ marginRight: 10 }} />
          </a>
          <a href="/" style={{ cursor: 'pointer' }}>
            <FontAwesome name="home" color="white" size={16} style={{ marginRight: 10 }} />
          </a>
        </span>
      );
    }

    return back;
  }

  loader = () => {
    return this.refs.loader;
  }

  dialog = () => {
    return this.refs.dialog;
  }

  render() {
    let padding = 15;
    let title = this.props.title ? ' - ' + this.props.title : null;
    let loading = this.props.loading;
    let loadingText = this.props.loadingText ? this.props.loadingText : 'Procesando...';
    let visible = 'block';

    if( this.props.visible === false ) {
      visible = 'none';
    }

    if( this.props.back !== false ) { padding = 13; }

    return (
      <header className="ms-bgColor-themePrimary ms-fontColor-white" style={{ padding: padding, display: visible }}>
        { this.backButton() }
        Gosalbez e Hijos { title }
        <Loading isOpen={ loading } label={ loadingText } ref="loader"/>
        <Message ref="dialog" />
      </header>
    )
  }
}


// WEBPACK FOOTER //
// ./src/component/Header.jsx